<template>
  <div class="wrap">
    <div class="topContain">
        <img src="../assets/static/homebgc.png" />
    </div>
    <div class="portrait">
        <img :src="avatarUrl" class="userPortrait" />
    </div>
    <div class="content">
        <div class="contentTop">
            <div class="rowAe">
                <div class="userName">{{nickname}}</div>
                <div>
                    <img class="sexIco" v-if="sex==1" src="../assets/static/man.svg" />
                    <img class="sexIco" v-else src="../assets/static/woman.svg" />
                </div>
            </div>
            <div class="phone">{{phone}}</div>
            <div class="rowAc itemLine">
                <div class="title">所属部门</div>
                <div>{{deptName}}</div>
            </div>
            <div class="rowAc itemLine">
                <div class="title">职位</div>
                <div>{{positionName}}</div>
            </div>
            <div class="rowAc itemLine">
                <div class="title">人事关系</div>
                <div>{{personnel[personnelStatus]}}</div>
            </div>
            <div class="rowAc itemLine">
                <div class="title">入职日期</div>
                <div>{{entryDate}}</div>
            </div>
            <div class="rowAc itemLine">
                <div class="title">是否上课</div>
                <div>
                    <img class="ico" v-if="isAttendClass==0" src="../assets/static/no.svg" />
                    <img class="ico" v-else src="../assets/static/yes.svg" />
                </div>
            </div>
        </div>
        <div class="contentBot">
            <div class="rowAc itemLine">
                <div class="title">账号</div>
                <div>{{username}}</div>
            </div>
            <div class="rowAc itemLine">
                <div class="title">用户角色</div>
                <div>{{userRole}}</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { getUserInfoAPI } from "../utils/api/api";
export default {
  data() {
    return {
        nickname:'',
        sex:0,
        phone:'',
        deptName:'',
        positionName:'',
        personnel:{
            0: '正式员工',
            1: '兼职员工', 
            2:'试用期',
            3: '转正失败', 
            4: '主动离职',
            5: '被解雇',
        },
        entryDate:'',
        isAttendClass:0,
        username:'',
        userRole:'',
        avatarUrl: '',
        personnelStatus:'',
        openid:'',
        innerAppId:'',
    };
  },
  created() {
      this.openid = JSON.parse(this.$common.getCache('openid'))
      this.innerAppId = JSON.parse(this.$common.getCache('innerAppId'))
  },
  mounted() {
      this.getList()
  },
  methods: {
      getList(){
            var obj = {
                openid:this.openid,
                innerAppId:this.innerAppId
            }
             getUserInfoAPI(obj)
            .then((res) => {
                console.log(res.data);
                if (res.resultCode == 200) {
                console.log("用户信息获取成功",res.data);
                this.nickname = res.data.nickname;
                this.sex = res.data.nickname;
                this.phone = res.data.phone;
                this.deptName = res.data.deptName;
                this.positionName = res.data.positionName;
                this.entryDate = res.data.entryDate;
                this.isAttendClass = res.data.isAttendClass;
                this.username = res.data.username;
                this.userRole = res.data.userRole;
                this.personnelStatus = res.data.personnelStatus;
                this.avatarUrl = res.data.avatarUrl
                }
            })
            .catch((err) => {
                console.log(err);
            });
        }
  },
};
</script>
<style lang="scss" scoped>
.wrap{
    height: 100%;
    background: linear-gradient(180deg, #DCEBFA 0%, #FAFBFD 100%);
    font-size: 14px;
}
.userPortrait{
  width: 104px;
  height: 104px;
}
.portrait {
  background-size: 100% 100%;
  overflow: hidden;
  border: 4px solid #FFFFFF;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  position: fixed;
  top: 74px;
  right: 0.4rem;
}
.content{
    height: 355px;
    background: #FFFFFF;
    padding: 0 0.2rem;
}
.contentTop{
    height: 261px;
    padding-top: 30px;
    border-bottom: 1px solid #E8E9EA;
    box-sizing: border-box;  
    color: #333843;
    line-height: 21px;
    letter-spacing: 1px;
    .userName{       
    font-size: 24px;
    font-weight: 500;
    color: #333843;
    line-height: 34px;
    margin-right: 6px;
    }
    .phone{       
    font-size: 16px;
    color: #333843;
    line-height: 23px;
    letter-spacing: 0px;
    margin-bottom: 20px;
    }
    .title{   
    width: 124px;    
    font-size: 14px;
    color: #999999;
    }
    .ico{
        width: 16px;
        height: 16px;
    }
}
.contentBot{
    height: 94px;
    color: #333843;
    line-height: 21px;
    letter-spacing: 1px;
    padding-top: 20px;
    .title{   
    width: 124px;    
    font-size: 14px;
    color: #999999;
    }
}
.itemLine{
    margin-bottom: 7PX;
}
.sexIco{
    margin-bottom: 5px;
}
</style>
